// some how get to see if content is loaded ?
import { debounce } from 'lodash'
import { reactLocalStorage } from 'reactjs-localstorage'
import axios from 'axios'
import Cookies from 'js-cookie'
import { promiseSetRecoil, promiseGetRecoil } from 'recoil-outside'
import { autoSavingStatus } from '@/store/onepager/onepager'

export default debounce(
  async (isLoggedIn, id, contentsDB, contentBlocksDB, isOnepagerForm) => {
    // IF SHARE ID, DO NOT AUTO SAVE
    if (findGetParameter('shareId')) {
      // do not autosave - using share ID
      // console.log('using share ID - changes are not presisted')
    } else {
      // CHECK IF LOGGED IN - USE CONTENT ID
      if (isLoggedIn) {
        // start auto save UI
        const startSavingUI = await promiseSetRecoil(autoSavingStatus, true)

        let email = Cookies.get('wl-email')
        let consent = Cookies.get('wl-submissionConsent')

        const getOnepagerContentID = await axios.post(
          '/api/rest/get-user-content-id',
          {
            email: email,
            templateId: id,
          }
        )

        if (getOnepagerContentID.data?.contentId) {
          const getCurrentContents = await axios.post(
            '/api/rest/get-user-content-by-id',
            {
              contentId: getOnepagerContentID.data.contentId['@ref'].id,
            }
          )

          const newContent = JSON.stringify(contentsDB)
          const oldContent = JSON.stringify(getCurrentContents.data.content)

          // save to server ...
          if (oldContent !== newContent) {
            const updateUserContent = await axios.post(
              '/api/rest/save-user-content-email',
              {
                email: email,
                submission: consent,
                templateId: id,
                content: JSON.stringify({
                  content: contentsDB,
                  content_blocks: contentBlocksDB,
                }),
              }
            )
            // remove anything from localstorage w/ this template ID
            reactLocalStorage.remove(id)
          }
        } else {
          const updateUserContent = await axios.post(
            '/api/rest/save-user-content-email',
            {
              email: email,
              submission: consent,
              templateId: id,
              content: JSON.stringify({
                content: contentsDB,
                content_blocks: contentBlocksDB,
              }),
            }
          )
          // remove anything from localstorage w/ this template ID
          reactLocalStorage.remove(id)
        }

        setTimeout(async () => {
          await promiseSetRecoil(autoSavingStatus, false)
        }, 1250)

        // }

        // console.log('updateUserContent', updateUserContent)
      } else {
        // console.log('not loged in auto save', id)
        // not logged in - store to local storage
        reactLocalStorage.setObject(id, {
          content: contentsDB,
          content_blocks: contentBlocksDB,
        })
      }
    }
  },
  2000
)

function findGetParameter(parameterName) {
  var result = null,
    tmp = []
  location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=')
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
    })
  return result
}
